// JavaScript Document
/*---------------lenis------------------*/
///lenis
const lenis = new Lenis({
  duration: 1,
  easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
  orientation: "vertical",
  gestureOrientation: "vertical",
  smoothWheel: true,
  smoothTouch: false,
  touchMultiplier: 2,
});
lenis.on("scroll", ScrollTrigger.update);
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
/*---------------lenis------------------*/

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  });
});


/*
* css swicher
*/
function css_browser_selector(u){
	var ua=u.toLowerCase(),
	is=function(t){return ua.indexOf(t)>-1},
	e='edge',g='gecko',w='webkit',s='safari',o='opera',m='mobile',
	h=document.documentElement,
	b=[
		( !(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua))? ('ie ie'+RegExp.$1) :
			!(/opera|webtv/i.test(ua)) && is('trident') && /rv:(\d+)/.test(ua)? ('ie ie'+RegExp.$1) :
			is('edge/')? e:
			is('firefox/2')?g+' ff2':
			is('firefox/3.5')? g+' ff3 ff3_5' :
			is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')? g+' ff3' :
			is('gecko/')?g:
			is('opera')? o+(/version\/(\d+)/.test(ua)? ' '+o+RegExp.$1 :
			(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')) :
			is('konqueror')? 'konqueror' :
			is('blackberry')?m+' blackberry' :
			is('android')?m+' android' :
			is('chrome')?w+' chrome' :
			is('iron')?w+' iron' :
			is('applewebkit/')? w+' '+s+(/version\/(\d+)/.test(ua)? ' '+s+RegExp.$1 : '') :
			is('mozilla/')? g:
			'',
			is('j2me')?m+' j2me':
			is('iphone')?m+' iphone':
			is('ipod')?m+' ipod':
			is('ipad')?m+' ipad':
			is('mac')?'mac':
			is('darwin')?'mac':
			is('webtv')?'webtv':
			is('win')? 'win'+(is('windows nt 6.0')?' vista':''):
			is('freebsd')?'freebsd':
			(is('x11')||is('linux'))?'linux':
			'',
			'js'];
	c = b.join(' ');
	h.className += ' '+c;
	return c;
};
css_browser_selector(navigator.userAgent);

/*---------------submenu------------------*/
$(function(){
  const submenuItem = $('.header-submenu,.js-megamenu-item');
  $('.js-megamenu-item').hover(function() {
    $(submenuItem).addClass('is-submenu-open');
  }, function() {
    $(submenuItem).removeClass('is-submenu-open');
  });

  $('.header-submenu').hover(function() {
    $(submenuItem).addClass('is-submenu-open');
  }, function() {
    $(submenuItem).removeClass('is-submenu-open');
  });
});

/*---------------menu------------------*/
$(function(){
  $('.js-toggle-button').on('click', function(){
    if(!$(this).hasClass('is-action')) {
      let scrollpos = $(window).scrollTop();
      $('body').addClass('is-fixed').css({'top': -scrollpos}).data('pos', scrollpos);
      $(this).addClass('is-action');
    } else {
      $('body').removeClass('is-fixed').css({'top': 0});
      window.scrollTo( 0 , $('body').data('pos') );
      $(this).removeClass('is-action');
    }

    if ($('.menu').css('visibility') == 'hidden') {
      $('.menu').addClass('is-action');
    } else {
      $('.menu').removeClass('is-action');
    }
  });
  $('menu a').on('click', function(){
    $('.js-toggle-button').click();
  });
});

/*---------------pagetop------------------*/

document.addEventListener("DOMContentLoaded", function () {
	  if ($('.js-pagetop').length) {
		  const pagetop_btn = document.querySelector(".js-pagetop");
		  pagetop_btn.addEventListener("click", scroll_top);

		  function scroll_top() {
			  window.scroll({top: 0, behavior: "smooth"});
		  };
	  }
});


$(window).scroll(function () {
  var cartDrawer = $(".cart-summary-overlay");
  cartDrawer.addClass("cart-summary-overlay--off-screen")
});

